import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TuningTextComponent } from './tuning-text/tuning-text.component';
import { BulletMenuComponent } from './bullet-menu/bullet-menu.component';
import { StringTuningComponent } from './LIB/components/string-tuning/string-tuning.component';
import { FretboardsComponent } from './LIB/components/fretboards/fretboards.component';
import { MarkdownModule } from 'ngx-markdown';
import { FormsModule } from '@angular/forms';
import { HomePage } from './home/home.page';
import { FretboardPage } from './fretboard/fretboard.page';
import { AboutPage } from './about/about.page';

@NgModule({
  declarations: [
    AppComponent,
    FretboardsComponent,
    StringTuningComponent,
    BulletMenuComponent,
    TuningTextComponent,
    HomePage,
    FretboardPage,
    AboutPage
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    FormsModule,
    MarkdownModule.forRoot()
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
